
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const quickLinks = [
    { label: 'Services', id: 'services' },
    { label: 'About', id: 'about' },
    { label: 'Process', id: 'process' },
    { label: 'Service Areas', id: 'service-areas' },
    { label: 'FAQs', id: 'faqs' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <footer className="bg-gradient-to-br from-blue-900 via-blue-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Left - Logo & Tagline */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-cyan-400 to-blue-400 rounded-lg flex items-center justify-center">
                <i className="ri-drop-fill text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold">X-Treme Aqua</h3>
                <p className="text-xs text-cyan-300 font-medium">Pressure Cleaning</p>
              </div>
            </div>
            <p className="text-sm text-blue-200 leading-relaxed">
              Premium pressure cleaning services in Miami. Fast, reliable, and results you can see.
            </p>
          </div>

          {/* Center - Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <nav className="space-y-2">
              {quickLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="block text-sm text-blue-200 hover:text-cyan-300 transition-colors"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Right - Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Get In Touch</h4>
            <div className="space-y-3">
              <a
                href="tel:3052793585"
                className="flex items-center space-x-2 text-cyan-300 hover:text-cyan-200 transition-colors"
              >
                <i className="ri-phone-fill"></i>
                <span className="text-xl font-bold">(305) 279-3585</span>
              </a>
              <p className="text-sm text-blue-200">
                <i className="ri-time-line mr-2"></i>
                Open 24 Hours Daily
              </p>
              <p className="text-sm text-blue-200">
                <i className="ri-map-pin-line mr-2"></i>
                Miami, FL 33165
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-blue-200 text-center md:text-left">
              © {new Date().getFullYear()} X-Treme Aqua Pressure Cleaning. All rights reserved.
            </p>
            <p className="text-xs text-blue-300 text-center">
              Free estimates available. Results may vary by surface condition.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-blue-300 hover:text-cyan-300 transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
